import React from 'react';
import { Box } from '@mui/material';
import { WhatsAppBannerIconV2 } from '../../../../../assets/svg-fc/WhatsAppBannerIcon';
import { ExclamationInCircleSvgV2 } from '../../../../../assets/svg-fc/ExclamationInCircleSvg';
import './ChatHeaderRightSection.scss';

interface ChatHeaderRightSectionProps {
  showWhatsAppIcon?: boolean;
  onWhatsAppClick: () => void;
  onExclamationClick: () => void;
}

const ChatHeaderRightSection: React.FC<ChatHeaderRightSectionProps> = ({
  onWhatsAppClick,
  onExclamationClick,
  showWhatsAppIcon = true,
}) => {

  return (
    <Box className="chatHeaderRight">
      {showWhatsAppIcon && (
        <Box className="iconButton" onClick={onWhatsAppClick}>
          <WhatsAppBannerIconV2 />
        </Box>
      )}
      <Box className="iconButton" onClick={onExclamationClick}>
        <ExclamationInCircleSvgV2 />
      </Box>
    </Box>
  );
};

export default ChatHeaderRightSection;
